import type { CaseRecord } from '../types'
export const caseRoute = (record: CaseRecord) => record.investigation?.route ?? `/casos/${record.slug}`
